<template>
    <div class="expands">
        <div class="ex-menu">
            <strong class="tit text-primary">维保记录</strong>
            <ButtonGroup>
                <Button size="small" type="primary" class="text-font-sm" @click="addMaintainData(rowData.small_project_id, rowData.name)"><Icon type="md-add" /> 创建维保记录</Button>
            </ButtonGroup>
        </div>
        <Table :stripe="true" border  size="small" :columns="columns" show-summary :summary-method="handleSummary" :data="rowData.maintainList" class="tables-x"  ref="selection" maxHeight="280" no-data-text="暂无数据记录">
            <template #title="{ row }">
                <div class="d-width text-primary cursor" :title="row.title" @click="showMaintainData(row.maintain_id)">
                    <span>{{row.title}}</span>
                </div>
            </template>
            <template #type_id="{ row }">
                <Tag color="blue">{{row.type_name}}</Tag>
            </template>
            <template #work_id="{ row }">
                <div class="d-width">
                    <Tag v-for="(item,idx) in row.work_list" :key="idx">{{item.real_name}}</Tag>
                </div>
            </template>
            <template #collected="{ row }">
                <div class="d-width" :title="'已收款金额：' + (row.collected ?? '0.00') + ' 元'">
                    <strong class="text-success">{{row.collected ?? '0.00'}}</strong>
                </div>
            </template>
            <template #expend_money="{ row }">
                <div class="d-width" :title="row.expend_money">
                    <strong class="text-orange">{{row.expend_money ?? '0.00'}}</strong>
                </div>
            </template>
            <template #status="{ row }">
                <Badge v-if="row.status === 1" color="orange" :text="row.status_name" />
                <Badge v-else-if="row.status === 2" color="red" :text="row.status_name" />
                <Badge v-else-if="row.status === 3" color="green" :text="row.status_name" />
                <Badge v-else color="#999999" text="其他" />
                <div v-if="row.status === 2 && row.reject_remark" class="text-font-sm text-danger" :title="row.reject_remark" style="margin-top: 2px;">
                    原因：{{row.reject_remark}}
                </div>
            </template>
           
            <template #action="{ row, index }">
                <a v-if="isManager && row.status === 1" class="text-font-sm text-success" @click="examineMaintainData(row.maintain_id, row.title)">审批</a>
                <Divider v-if="isManager && row.status === 1" type="vertical"/>
                <a v-if="row.status !== 3" class="text-font-sm text-primary" @click="editMaintainData(row.maintain_id)">编辑</a>
                <Divider v-if="row.status !== 3" type="vertical"/>
                <a class="text-font-sm text-danger" @click="deleteMaintainData(row.maintain_id, index)">删除</a>
            </template>
        </Table>

        <!-- 创建/编辑维保记录  -->
        <add-maintain-modal v-if="is_maintain_add" ref="AddMaintainRef" @trueHandler="saveData"></add-maintain-modal>

        <!-- 维保审批  -->
        <examine-maintain-modal v-if="is_maintain_examine" ref="ExamineMaintainRef" @trueHandler="saveData"></examine-maintain-modal>

        <!-- 维保记录详情  -->
        <show-maintain-modal v-if="is_maintain_show" ref="ShowMaintainRef"></show-maintain-modal>
    </div>

</template>

<script>
import AddMaintainModal from "./MaintainCreate";
import ShowMaintainModal from "./MaintainShow";
import ExamineMaintainModal from "./MaintainExamine";
import {deleteMaintain} from "@/apis/dispersed";

export default {
    props: {
        rowData: {
            type: Object
        }
    },
    components: {
        AddMaintainModal, ShowMaintainModal, ExamineMaintainModal
    },
    emits: ['reloadData'],
    data () {
        return {
            columns: [
                {
                    title: '维保标题',
                    key: 'title',
                    slot: 'title',
                    width : 180
                },
                {
                    title: '维保类型',
                    key: 'type_id',
                    slot: 'type_id',
                    width : 120
                },
                {
                    title: '维保金额',
                    key: 'money',
                    width : 120
                },
                {
                    title: '已收款金额',
                    key: 'collected',
                    slot: 'collected',
                    width: 110
                },
                {
                    title: '支出金额',
                    key: 'expend_money',
                    slot: 'expend_money',
                    width: 100
                },
                {
                    title: '联系人',
                    key: 'contact_name',
                    width : 120
                },
                {
                    title: '联系电话',
                    key: 'contact_mobile',
                    width: 120
                },
                {
                    title: '负责人',
                    key: 'head_name',
                    width: 110
                },
                {
                    title: '施工人员',
                    key: 'work_id',
                    slot: 'work_id',
                    minWidth: 120
                },
                {
                    title: '开始时间',
                    key: 'start_time',
                    width: 100
                },
                {
                    title: '结束时间',
                    key: 'end_time',
                    width: 100
                },
                {
                    title: '维保状态',
                    key: 'status',
                    slot: 'status',
                    width: 100
                },
                
                {
                    title: '',
                    key: 'action',
                    slot : 'action',
                    width : 150
                }
            ],
            is_maintain_add : false,
            is_maintain_show : false,
            is_maintain_examine : false,
        }
    },
    computed: {
        //审批权限：仅经理角色（超管/总经理）
        isManager(){
            let gid = parseInt(this.$store.state.userinfo.group_id);
            return gid === 1 || gid === 2;
        }
    },
    created(){

    },
    methods: {
        /**
         * 功能：维保审批
         * time: 2026/10/06
         **/
        examineMaintainData(maintain_id, title){
            let that = this;
            that.is_maintain_examine = true;
            setTimeout(function(){
                that.$refs.ExamineMaintainRef.show(maintain_id, title);
            })
        },
        /**
         功能：创建维保记录
         time: 2026/09/12
         **/
        addMaintainData(small_project_id, name){
            let that = this;
            that.is_maintain_add = true;
            setTimeout(function(){
                that.$refs.AddMaintainRef.add(small_project_id, name);
            })
        },
        /**
         功能：编辑维保记录
         time: 2026/09/12
         **/
        editMaintainData(maintain_id){
            let that = this;
            that.is_maintain_add = true;
            setTimeout(function(){
                that.$refs.AddMaintainRef.edit(maintain_id);
            })
        },
        /**
         功能：维保记录详情
         time: 2026/09/12
         **/
        showMaintainData(maintain_id){
            let that = this;
            that.is_maintain_show = true;
            setTimeout(function(){
                that.$refs.ShowMaintainRef.show(maintain_id);
            })
        },
        /**
         功能：删除维保记录
         time: 2026/09/12
         **/
        deleteMaintainData(maintain_id, index){
            let that = this;
            if(!maintain_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除维保记录',
                content: '此操作将删除维保记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteMaintain(maintain_id).then( e =>{
                        that.rowData.maintainList.splice(index , 1);
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                    })
                },
                onCancel: () => {}
            });
        },
        /**
         功能：操作返回刷新
         time: 2026/09/12
         **/
        saveData(){
            this.$emit('reloadData', this.rowData.small_project_id);
        },
        /**
         功能：统计
         time: 2026/09/12
         **/
        handleSummary ({ columns, data }) {
            const sums = {};
            columns.forEach((column, index) => {
                const key = column.key;
                if (index === 0) {
                    sums[key] = {
                        key,
                        value: '统计'
                    };
                    return;
                }
                const values = data.map(item => Number(item[key]));
                if (!values.every(value => isNaN(value))) {
                    const v = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if(key === 'money' || key === 'expend_money' || key === 'collected'){
                        sums[key] = {
                            key,
                            value: v.toFixed(2) + ' 元'
                        };
                    }else{
                        sums[key] = {
                            key,
                            value: '-'
                        };
                    }

                } else {
                    sums[key] = {
                        key,
                        value: '-'
                    };
                }
            });

            return sums;
        },

    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.expands{
    padding: 15px 15px 20px !important;
    background: #ddd !important;
    width: calc(100vw - 242px);

    .ex-menu {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        &.ex-menu-top {
            margin-top: 20px;
        }
    }
}
</style>
